<template>
  <aside class="PromoPopupWrapper">
    <DesktopView v-if="deviceVariant === 'desktop'" :content="content" v-bind="{ triggered, triggeredBy }" />
    <MobileView v-if="deviceVariant === 'mobile'" :content="content" v-bind="{ triggered }" />
  </aside>
</template>

<script>
import DesktopView from './DesktopView.vue'
import MobileView from './MobileView.vue'
import customMedia from '~/data/custom-media.json'

const MILLIS_BEFORE_POPUP_APPEARS = 10e3
const AMOUNT_SCROLLED_BEFORE_POPUP_APPEARS = 0.3  // i.e., 30%

export default {
  components: {
    DesktopView,
    MobileView,
  },
  props: {
    content: Object,
  },
  data() {
    return {
      triggered: false,
      triggeredBy: '',
      deviceVariant: 'unknown',
    }
  },
  mounted() {
    if (typeof window !== 'undefined' && this.content.kind) {
      // Note that this is not robust as it relies on the PromoPopup being mounted after the
      // GatedContentDownloadModule, not sure how else to do it though.
      if (sessionStorage['gatedContentModalStatus'] !== 'active') {
        const showPopupAfterTimeout = () => {
          this.triggeredBy = 'timeout'
          this.triggered = true
        }
        const timeoutId = window.setTimeout(showPopupAfterTimeout, MILLIS_BEFORE_POPUP_APPEARS)
        const cancelTimedPopupReveal = () => {
          window.clearTimeout(timeoutId)
          window.removeEventListener('scroll', cancelTimedPopupReveal)
        }
        const maybeShowPopupAfterScrolling = () => {
          const amountScrolled = (scrollY + 0.5 * innerHeight) / document.body.scrollHeight
          if (amountScrolled > AMOUNT_SCROLLED_BEFORE_POPUP_APPEARS) {
            this.triggeredBy = 'scrolling'
            this.triggered = true
            window.removeEventListener('scroll', maybeShowPopupAfterScrolling)
          }
        }
        window.addEventListener('scroll', cancelTimedPopupReveal)
        window.addEventListener('scroll', maybeShowPopupAfterScrolling)
      }
      this.deviceVariant = matchMedia(customMedia['--screen-lg']).matches ? 'desktop' : 'mobile'
    }
  },
}
</script>
